export const locale = {
    lang: 'nl',
    data: {
      'MODALES': {
        'ERROR_DATOS':'Er is een fout opgetreden A-721',
        'VALIDACION':{
          'ERROR1': 'Je hebt een vraag zonder vertaling',
          'WARNING-SIN-TRADUCCION': 'Gelieve uw reagensvertaling toe te voegen',
          'MODAL-GUARDANDO': 'Besparing Reactief'
        },
        'TITULO': 'Een fout gemaakt',
        'TITULOS': {
          'error': 'Een fout gemaakt',
          'adver': 'Waarschuwing',
          'aviso': 'waarschuwing',
          'opSuc': 'Actie voltooid',
        },
        'ACCIONES': {
          'aceptar' : 'Accepteren',
          'cancelar': 'Annuleren',
          'INFORMATIVO': 'Laat dit bericht niet meer zien'
        },
        'EXPEDIENTES':{
          'Resultados': 'Je hebt het resultaat nog niet',
          'CARGANDO_COLABORADORES': 'Laadmedewerkers die medisch toezicht nodig hebben',
        },
        'MENSAJES': {
          'NO_FECH_LAN':'Onvolledige gegevens, selecteer product release datum',
          'NO_RESU_ACTI':'Op dit moment zijn de resultaten niet beschikbaar, probeer het later nog eens.',
          'OK':'OK',
          'Something is wrong': 'Er is iets mis',
         'password wrong': 'Het door u ingevoerde wachtwoord is foutief',
          'User does not exist': 'De door u ingevoerde e-mail is niet geregistreerd in CulturalGO',
          'Error': 'de collabs werden gered :V',
          'Fout: gebruiker bestaat al': 'De gebruiker met deze e-mail bestaat al',
          'CONEX': {
            'SIN': 'Uw apparaat heeft geen internetverbinding meer. Om het platform te blijven gebruiken, sluit u uw apparaat aan op het internet',
            'CON': 'Uw apparaat heeft de internetverbinding hersteld. Nu kunt u verdergaan met het gebruik van het platform'
          },
          'WIZARD': {
            'CERTIFICAR' : {
              'RESTRICCIONES': {
                'Rest1': 'Om toegang te krijgen tot dit gedeelte moet u de <b>talen</b> voor de enquête instellen',
                'Rest2': 'Om toegang te krijgen tot dit gedeelte moet u alle voorgaande stappen doorlopen',
                'Rest3': 'Om toegang te krijgen tot dit gedeelte moet u <b> de lancering van de enquête plannen</b>',
                'Rest4': 'Om toegang te krijgen tot dit gedeelte moet u de <b>mail verzenden</b> hebben gedaan en moet de enquête zijn gestart',
                'Rest5': 'Om toegang te krijgen tot dit gedeelte moet u de <b>Demografie</b> instellen voor de enquête'
              },
              'IDIOMAS': {
                'NADA': 'U bent niet begonnen met de selectie van de talen',
                'NADA2': 'Je hebt nog geen releasedatum gepland',
                'NADA4': 'U bent nog niet begonnen met de datumherinnering',
                'NODEFAULT': 'U hebt de hoofdtaal nog niet geselecteerd',
                'NOADICIONAAL': 'U hebt nog geen extra taal geselecteerd',
                'COMPLETAR': 'Weet u zeker dat u deze stap als voltooid markeert met de huidige taalkeuze?',
                '210': 'De stap is met succes voltooid',
                'COMPLETADO': 'U hebt deze stap al voltooid',
                'RESTRICCION': 'Het is niet mogelijk om deze actie uit te voeren nadat u deze stap hebt voltooid',
                'INFORMATIVO': 'In dit gedeelte kunt u de hoofdtaal en aanvullende talen kiezen waarin de enquête aan de medewerkers wordt gepresenteerd',
                'ARCHIVOCOMFIRM': 'Waarschuwing! Zorg ervoor dat u het Excel-bestand op één enkel besturingssysteem werkt om coderingsconflicten te vermijden.',
                'BOTONTEXTO': 'Begrepen',

                'TITULO_DESBLOQUEAR': '<span>Weet u zeker dat u de taalpassages wilt heropenen, merk dan op dat dit <font color="red"> uw huidige product herstarten</font> en alle informatie die u aan de secties hebt toegevoegd, verwijderen? </span>',
                'BOTON_CONFIRM': 'Ja, heropenen',
                'BOTON_CANCEL': 'Annuleren',
                'SUCCES': 'De stap is met succes heropend',
                'BLOQUEADO': 'De stap is nu open',
                'CERRAR': 'Sluiten'
              },
              'TEMPLATE': {
                // 'NADA': 'Aún no ha realizado la selección de los idiomas principal y adicionales',
                // 'NODEFAULT': 'Aún no ha seleccionado el idioma principal',
                // 'NOADICIONAL': 'Aún no ha seleccionado idiomas adicionales',
                // 'COMPLETAR': '¿Está seguro de completar el paso con la selección actual de idiomas?',
                // '210': 'El paso se completó correctamente',
                // 'COMPLETADO': 'Ya ha completado este paso',
                // 'RESTRICCION': 'No es posible realizar esta acción una vez que ya ha completado este paso',
                'INFORMATIVO': 'In dit gedeelte kunt u wijzigingen aanbrengen in het sjabloon',
                // 'ARCHIVOCOMFIRM':'¡Advertencia! Asegúrate de trabajar el archivo de Excel en un único sistema operativo para evitar conflictos de codificación',
                // 'BOTONTEXTO':'Enterado',

                // 'TITULO_DESBLOQUEAR': '<span>¿Está seguro de reabrir el paso de idiomas, tenga en cuenta que esto <font color="red">reiniciará</font> su producto actual y borrará toda la información que haya agregado a las secciones?</span>',
                // 'BOTON_CONFIRM': 'Sí, reabrir',
                // 'BOTON_CANCEL': 'Cancelar',
                // 'SUCCES': 'El paso ha sido reabierto con éxito',
                // 'BLOQUEADO': 'El paso ya esta abierto',
                // 'CERRAR': 'Cerrar'
              },
              'NPS': {
                'NADA': 'U hebt geen NPS aangemaakt of de optie zonder NPS gemarkeerd',
                'COMPLETAR': 'Weet u zeker dat u de stap met uw huidige NPS kunt voltooien?',
                '219': 'De stap is met succes voltooid',
                '220': 'De stap is met succes gezet',
                'COMPLETADO': 'U hebt deze stap al voltooid',
                'RESTRICCION': 'Het is niet mogelijk om deze actie uit te voeren nadat u deze stap hebt voltooid',
                'INFORMATIVO': 'In dit gedeelte kunt u uw NPS voor de enquête wijzigen',
                'FALTANTEN': 'Je hebt je NPS nog niet ingevuld',
                'FALTANTES_TRADUCCIONES': 'U bent nog niet klaar met het invullen van de vertalingen voor alle vragen',
                'FALTANTES_SECCIONES_ESPECIALES': 'U hebt de sleutel van de speciale sectie nog niet ingevoerd',
                'FALTANTES_RESPUESTAS': 'U kunt deze stap nog niet voltooien, alle meerkeuzevragen moeten minimaal twee antwoordopties hebben',
                'SIN_PREGUNTAS': 'U moet ten minste één vraag toevoegen om de stap te voltooien',
                'SIN_GRUPOS': 'U moet ten minste één vraaggroep toevoegen met een vraag erin om de stap te voltooien',

                'TITULO_DESBLOQUEAR': 'Weet je zeker dat je de NPS-stap weer opent?',
                'BOTON_CONFIRM': 'Ja, heropenen',
                'BOTON_CANCEL': 'Annuleren',
                'SUCCES': 'De stap is met succes heropend',
                'BLOQUEADO': 'De stap is nu open',
                'CERRAR': 'Sluiten'
              },
              'REACTIVOS': {
                'NADA': 'U hebt geen verklaringen gemaakt of de optie zonder verklaringen gemarkeerd',
                'COMPLETAR': 'Weet u zeker dat u deze stap als voltooid markeert met de huidige verklaringen?',
                '218': 'De stap is met succes voltooid',
                'COMPLETADO': 'U hebt deze stap al voltooid',
                'RESTRICCION': 'Het is niet mogelijk om deze actie uit te voeren nadat u deze stap hebt voltooid',
                'INFORMATIVO': 'In dit gedeelte kunt u verklaringen toevoegen aan de enquête',
                'FALTANTEN': 'U hebt uw verklaringen nog niet ingevuld',
                'FALTANTES_TRADUCCIONES': 'U bent nog niet klaar met het invullen van de vertalingen voor alle vragen',
                'FALTANTES_SECCIONES_ESPECIALES': 'U hebt de sleutel van de speciale sectie nog niet ingevoerd',
                'FALTANTES_RESPUESTAS': 'U kunt deze stap nog niet voltooien, alle meerkeuzevragen moeten minimaal twee antwoordopties hebben',
                'SIN_PREGUNTAS': 'U moet ten minste één vraag toevoegen om de stap te voltooien',
                'SIN_GRUPOS': 'U moet ten minste één vraaggroep toevoegen met een vraag erin om de stap te voltooien',

                'TITULO_DESBLOQUEAR': 'Weet u zeker dat u de stap naar de verklaringen opnieuw opent?',
                'BOTON_CONFIRM': 'Ja, heropenen',
                'BOTON_CANCEL': 'Annuleren',
                'SUCCES': 'De stap is met succes heropend',
                'BLOQUEADO': 'De stap is nu open',
                'CERRAR': 'Sluiten'
              },
              'FORALL': {
                'NADA': 'U bent nog niet klaar met het vullen van de 4ALL-praktijken',
                'COMPLETAR': 'Weet u zeker dat u deze stap als voltooid markeert met de huidige For All-praktijken?',
                '212': 'De stap is met succes voltooid',
                'COMPLETADO': 'U hebt deze stap al voltooid',
                'RESTRICCION': 'Het is niet mogelijk om deze actie uit te voeren nadat u deze stap hebt voltooid',
                'INFORMATIVO': 'Dit deel geeft een overzicht van de praktijken die in de onderneming worden toegepast en waarbij alle werknemers betrokken zijn',
                'NADA_TRA': 'U bent nog niet klaar met de vertaling van uw 4ALL-praktijken',
                'FALTANTES_TRADUCCIONES': 'U bent nog niet klaar met het invullen van de vertalingen voor alle vragen',
                'FALTANTES_SECCIONES_ESPECIALES': 'U hebt de sleutel van de speciale sectie nog niet ingevoerd',
                'FALTANTES_RESPUESTAS': 'U kunt deze stap nog niet voltooien, alle meerkeuzevragen moeten minimaal twee antwoordopties hebben',
                'SIN_PREGUNTAS': 'U moet ten minste één vraag toevoegen om de stap te voltooien',
                'SIN_GRUPOS': 'U moet ten minste één vraaggroep toevoegen met een vraag erin om de stap te voltooien',

                'TITULO_DESBLOQUEAR': 'Weet u zeker dat u de stap van de 4ALL-praktijken opnieuw opent?',
                'BOTON_CONFIRM': 'Ja, heropenen',
                'BOTON_CANCEL': 'Annuleren',
                'SUCCES': 'De stap is met succes heropend',
                'BLOQUEADO': 'De stap is nu open',
                'CERRAR': 'Sluiten'
              },
              'CONTROL': {
                'NADA': 'U hebt geen controlevragen gemaakt of de optie zonder controle gemarkeerd',
                'COMPLETAR': 'Weet u zeker dat u de stap met uw huidige controlevraag wilt voltooien?',
                '221': 'De stap is met succes afgerond',
                'COMPLETADO': 'U hebt deze stap al voltooid',
                'RESTRICCION': 'Het is niet mogelijk om deze actie uit te voeren nadat u deze stap hebt voltooid',
                'INFORMATIVO': 'In dit gedeelte kunt u uw enquêtecontrolevraag aanpassen',
                'FALTANTEN': 'U heeft uw controlevraag nog niet ingevuld',
                'FALTANTES_TRADUCCIONES': 'U bent nog niet klaar met het invullen van de vertalingen voor alle vragen',
                'FALTANTES_SECCIONES_ESPECIALES': 'U hebt de sleutel van de speciale sectie nog niet ingevoerd',
                'FALTANTES_RESPUESTAS': 'U kunt deze stap nog niet voltooien, alle meerkeuzevragen moeten minimaal twee antwoordopties hebben',
                'SIN_PREGUNTAS': 'U moet ten minste één vraag toevoegen om de stap te voltooien',
                'SIN_GRUPOS': 'U moet ten minste één vraaggroep toevoegen met een vraag erin om de stap te voltooien',

                'TITULO_DESBLOQUEAR': 'Weet u zeker dat u de stap van de controlevraag opnieuw opent?',
                'BOTON_CONFIRM': 'Ja, heropenen',
                'BOTON_CANCEL': 'Annuleren',
                'SUCCES': 'De stap is met succes heropend',
                'BLOQUEADO': 'De stap is nu open',
                'CERRAR': 'Sluiten'
              },
              'DEMOGRAFICOS': {
                'NADA': 'Je hebt nog geen keuze gemaakt voor de demografie',
                'COMPLETAR': 'Weet u zeker dat u deze stap met de huidige demografische informatie aanvult?',
                '213': 'De stap is met succes voltooid',
                'COMPLETADO': 'U hebt deze stap al voltooid',
                'RESTRICCION': 'Het is niet mogelijk om deze actie uit te voeren nadat u deze stap hebt voltooid',
                'INFORMATIVO': 'In dit deel worden de demografische opties vastgesteld die aan de werknemers in de enquête ter beschikking zullen worden gesteld',
                'FALTANTES_TRADUCCIONES': 'U bent nog niet klaar met het invullen van de vertalingen voor alle vragen',
                'FALTANTES_SECCIONES_ESPECIALES': 'U hebt de sleutel van de speciale sectie nog niet ingevoerd',
                'FALTANTES_RESPUESTAS': 'U kunt deze stap nog niet voltooien, alle meerkeuzevragen moeten minimaal twee antwoordopties hebben',
                'SIN_PREGUNTAS': 'U moet ten minste één vraag toevoegen om de stap te voltooien',
                'SIN_GRUPOS': 'U moet ten minste één vraaggroep toevoegen met een vraag erin om de stap te voltooien',

                'TITULO_DESBLOQUEAR': 'Weet u zeker dat u de demografiestap herneemt?',
                'BOTON_CONFIRM': 'Ja, heropenen',
                'BOTON_CANCEL': 'Annuleren',
                'SUCCES': 'De stap is met succes heropend',
                'BLOQUEADO': 'De stap is nu open',
                'CERRAR': 'Sluiten'
              },
              'ABIERTAS': {
                'NADA': 'U hebt geen open vraag gemaakt of de optie zonder open vragen gemarkeerd',
                'COMPLETAR': 'Weet u zeker dat u deze stap als voltooid markeert met de huidige open vragen?',
                '220': 'De stap is met succes voltooid',
                'COMPLETADO': 'U hebt deze stap al voltooid',
                'RESTRICCION': 'Het is niet mogelijk om deze actie uit te voeren nadat u deze stap hebt voltooid',
                'INFORMATIVO': 'In deze sectie kunt u open vragen toevoegen om uw medewerkers schriftelijke feedback te krijgen',
                'FALTANTEN': 'U heeft uw open vragen nog niet ingevuld',
                'FALTANTES_TRADUCCIONES': 'U bent nog niet klaar met het invullen van de vertalingen voor alle vragen',
                'FALTANTES_SECCIONES_ESPECIALES': 'U hebt de sleutel van de speciale sectie nog niet ingevoerd',
                'FALTANTES_RESPUESTAS': 'U kunt deze stap nog niet voltooien, alle meerkeuzevragen moeten minimaal twee antwoordopties hebben',
                'SIN_PREGUNTAS': 'U moet ten minste één vraag toevoegen om de stap te voltooien',
                'SIN_GRUPOS': 'U moet ten minste één vraaggroep toevoegen met een vraag erin om de stap te voltooien',

                'TITULO_DESBLOQUEAR': 'Weet u zeker dat u de open vragenstap herneemt?',
                'BOTON_CONFIRM': 'Ja, heropenen',
                'BOTON_CANCEL': 'Annuleren',
                'SUCCES': 'De stap is met succes heropend',
                'BLOQUEADO': 'De stap is nu open',
                'CERRAR': 'Sluiten'
              },
              'ADICIONALES': {
                'NADA': 'U hebt geen extra vraag gemaakt of de optie zonder extra vragen gemarkeerd',
                'COMPLETAR': 'Weet u zeker dat u deze stap als voltooid markeert met de huidige aanvullende vragen?',
                '214': 'De stap is met succes voltooid',
                'COMPLETADO': 'U hebt deze stap al voltooid',
                'RESTRICCION': 'Het is niet mogelijk om deze actie uit te voeren nadat u deze stap hebt voltooid',
                'INFORMATIVO': 'In dit gedeelte kunt u aangepaste vragen toevoegen aan de enquête',
                'FALTANTES_TRADUCCIONES': 'U bent nog niet klaar met het invullen van de vertalingen voor alle vragen',
                'FALTANTES_SECCIONES_ESPECIALES': 'U hebt de sleutel van de speciale sectie nog niet ingevoerd',
                'FALTANTES_RESPUESTAS': 'U kunt deze stap nog niet voltooien, alle meerkeuzevragen moeten minimaal twee antwoordopties hebben',
                'SIN_PREGUNTAS': 'U moet ten minste één vraag toevoegen om de stap te voltooien',
                'SIN_GRUPOS': 'U moet ten minste één vraaggroep toevoegen met een vraag erin om de stap te voltooien',

                'TITULO_DESBLOQUEAR': 'Weet u zeker dat u de extra stap opnieuw zult openen?',
                'BOTON_CONFIRM': 'Ja, heropenen',
                'BOTON_CANCEL': 'Annuleren',
                'SUCCES': 'De stap is met succes heropend',
                'BLOQUEADO': 'De stap is nu open',
                'CERRAR': 'Sluiten'
              },
              'COLABORADORES': {
                'NADA': 'U heeft uw deelnemersdatabank niet geladen',
                'COMPLETAR': 'Weet u zeker dat u deze stap met de huidige deelnemersdatabase aanvult?',
                '211': 'De stap is met succes voltooid',
                '200': 'De stap is met succes gezet',
                '219': 'De stap is met succes voltooid',
                'COMPLETADO': 'U hebt deze stap al voltooid',
                'RESTRICCION': 'Het is niet mogelijk om deze actie uit te voeren nadat u deze stap hebt voltooid',
                'INFORMATIVO': 'Dit gedeelte laadt de lijst van medewerkers naar wie de uitnodiging voor de enquête via e-mail wordt gestuurd',
                'ACTUALIZAR': 'De medewerkers zijn correct aan de enquête toegevoegd',

                'TITULO_DESBLOQUEAR': 'Weet u zeker dat u de stap van de deelnemers opnieuw zult openen?',
                'BOTON_CONFIRM': 'Ja, heropenen',
                'BOTON_CANCEL': 'Annuleren',
                'SUCCES': 'De stap is met succes heropend',
                'BLOQUEADO': 'De stap is nu open',
                'CERRAR': 'Sluiten'
              },
              'PROGRAMACION': {
                'NADA': 'Je hebt geen datum gepland',
                'COMPLETAR': 'Weet u zeker dat u deze stap als voltooid markeert met de huidige planningsdatum?',
                'GENERAR': 'Weet u zeker dat u deze stap als voltooid markeert?',
                '215': 'De stap is met succes voltooid',
                '217': 'De stap is met succes voltooid', //CERTIFICAR2.0
                'COMPLETADO': 'U hebt deze stap al voltooid',
                'FECHALANZAMIENTO': 'U hebt uw releasedatum nog niet ingevuld',
                'RESTRICCION': 'Het is niet mogelijk om deze actie uit te voeren nadat u deze stap hebt voltooid',
                'INFORMATIVO': 'In dit deel worden de data voor de lancering en verzending van de herinneringen voor de voltooiing van de enquête vastgesteld',
                'INFORMATIVO2': 'In dit gedeelte worden de data voor het verzenden van de Pulse Check vastgesteld',
                'GUARDA-OK': 'De datum is succesvol opgeslagen',
                'OK': 'OK',

                'TITULO_DESBLOQUEAR': 'Weet u zeker dat u de stap voor het maken van de enquête opnieuw opent?',
                'TITULO_DESBLOQUEAR2': 'Weet u zeker dat u de geplande stap voor de enquête opnieuw opent?',
                'BOTON_CONFIRM': 'Ja, heropenen',
                'BOTON_CANCEL': 'Annuleren',
                'SUCCES': 'De stap is met succes heropend',
                'BLOQUEADO': 'De stap is nu open',
                'CERRAR': 'Sluiten',
                'NOT_MESS_COM':'Deze functie is niet toegestaan',
                'DETEC_CAMBIOS_SECCIONES':'Als er veranderingen zijn geconstateerd in de configuratie van de secties, moet de enquête opnieuw worden gegenereerd.',
              },
              'ENVIO': {
                'NADA': 'U hebt de uitnodigingsmail voor de enquête nog niet verstuurd naar uw medewerkers',
                'NADA_OPCION': 'U hebt nog niet geconfigureerd of de uitnodiging per e-mail wordt verstuurd',
                'COMPLETAR': 'Weet u zeker dat u deze stap als voltooid markeert?',
                '216': 'De stap is met succes voltooid',
                'COMPLETADO': 'U hebt deze stap al voltooid',
                'RESTRICCION': 'Het is niet mogelijk om deze actie uit te voeren nadat u deze stap hebt voltooid',
                'INFORMATIVO': 'In dit gedeelte kunt u de uitnodigingen voor de proefenquête versturen',

                'TITULO_DESBLOQUEAR': 'Weet u zeker dat u de stap naar de afzender van de post zult heropenen?',
                'BOTON_CONFIRM': 'Ja, heropenen',
                'BOTON_CANCEL': 'Annuleren',
                'SUCCES': 'De stap is met succes heropend',
                'BLOQUEADO': 'De stap is nu open',
                'CERRAR': 'Sluiten'
              },
              'CONFIRMACION': {
                // 'NADA': 'Aún no ha realizado el envío de la invitación a la encuesta a sus colaboradores',
                // 'NADA_OPCION': 'Aún no ha configurado si el envío de la invitación se hará por correo electrónico',
                // 'COMPLETAR': '¿Está seguro de completar el paso?',
                // '216': 'El paso se completó correctamente',
                // 'COMPLETADO': 'Ya ha completado este paso',
                // 'RESTRICCION': 'No es posible realizar esta acción una vez que ya ha completado este paso',
                 'INFORMATIVO': 'In dit gedeelte kunt u de enquête activeren of deactiveren.',
                // 'TITULO_DESBLOQUEAR': '¿Está seguro de reabrir el paso de envío de correos?',
                // 'BOTON_CONFIRM': 'Sí, reabrir',
                // 'BOTON_CANCEL': 'Cancelar',
                // 'SUCCES': 'El paso ha sido reabierto con éxito',
                // 'BLOQUEADO': 'El paso ya esta abierto',
                // 'CERRAR': 'Cerrar'
              },
              'CIERRE': {
                'NADA': 'Het onderzoek is nog niet afgerond',
                'COMPLETAR': 'Weet u zeker dat u deze stap als voltooid markeert?',
                '217': 'De stap is met succes voltooid',
                'COMPLETADO': 'U hebt deze stap al voltooid',
                'RESTRICCION': 'Het is niet mogelijk om deze actie uit te voeren nadat u deze stap hebt voltooid',
                'INFORMATIVO': 'In dit deel kan het huidige verloop van het onderzoek worden geraadpleegd, evenals de vervroegde afsluiting van het onderzoek',
                'INFORMATIVO2': 'In dit gedeelte kunt u de huidige voortgang van elk van de gelanceerde Pulse Check onderzoeken controleren'
              }
            },
            'NOM35': {
              'CENTROS': {
                'AUTOLOGIN': {
                  'TITULO': 'Waarschuwing',
                  'INFO': 'Waarschuwing: Uw sessie wordt afgesloten en het platform gaat verder met het inloggen als het geselecteerde werkcentrum. Bevestig je dat je inlogt als het geselecteerde werkcentrum?',
                  'INFOODS': 'Waarschuwing: uw sessie wordt afgesloten en het platform gaat verder om in te loggen als het geselecteerde bedrijf. Bevestigt u om in te loggen als het geselecteerde bedrijf?',
                }
              }
            },
            'FOCUS':{
              'MODAL-AUNAUTORIZACION': 'Nog niet geautoriseerd',
              'BTN-ENTERADO': 'ENTER',
              'MODAL-AUTORIZACION': 'Uw enquête is verzonden om te valideren',


            },
          }
        },
        'ERRORES': {
          'Ocurrió un error desconocido': 'Uw computer of apparaat vertoont een verbindingsfout met het platform, probeer het later opnieuw te openen',
          '102': 'Het ingevulde e-mailadres is niet geregistreerd in het CulturalGO',
          '103': 'Het ingevoerde wachtwoord is verkeerd',
          '101': 'De gebruiker met deze e-mail bestaat al',
          // 'verifyToken_3': '<span>Het platform heeft onlangs een update gehad, om deze reden en om verlies van informatie te voorkomen, zal uw sessie worden afgesloten<br><br> Om de goede werking van het platform te garanderen, vragen we u om uw browser te updaten met de <font-kleur='rood'>CTRL + F5</font> toetscombinatie.</span>',
          // 'tokenActLogin': '<span>Het platform heeft onlangs een update gehad, om deze reden en om de juiste werking van het platform te garanderen, vragen we u om uw browser te updaten met de toetscombinatie <font-kleur='rood'>CTRL + F5</font>, later kunt u normaal toegang krijgen tot het platform</span>'.
          'verifyToken_3': '<span>Het platform is recentelijk geüpdatet, om deze reden en om verlies van informatie te voorkomen, zal uw sessie worden afgesloten<br><br>Om de goede werking van het platform te waarborgen, zal <font-kleur="rood">uw browser automatisch worden geüpdatet</font></span>',
          'tokenActLogin': '<span>Het platform heeft onlangs een update gehad, om deze reden en om de juiste werking van het platform te garanderen, <font-kleur="rood">uw browser wordt automatisch geüpdatet</font>, later kun je het platform normaal gebruiken</span>',
          'Demosleutels niet op voorraad': 'Demo-gebruikers van de enquête zijn uitgeput',
          'Keys Out Of Stock': 'Demo-gebruikers van de enquête zijn uitgeput',
          'Error: Please Recreate Survey':'Er zijn wijzigingen ontdekt in de vragen.\n\n Om verder te gaan, gelieve de enquête opnieuw te maken.',
          'IT Manager Not Found':'De e-mail is niet naar de IT-manager gestuurd.\n\n voer de e-mail in en verstuur hem handmatig.',
          'NO_PROCC_PROD_ASO':'Het bijbehorende product is op dit moment nog niet verwerkt',
          'ERR_PROCC_PROD_ACT': 'Fout bij het bijwerken van gebruikers in SQL',
          '300':'De ingevoerde e-mail heeft geen toegangsrechten',
        },
        'ELIMINAR':{
          'MENSAJETEXTO1': '<span>Om de verkoop van het bedrijf te bevestigen',
          'MENSAJETEXTO2': ', vul de bedrijfsnaam in het tekstvak</span>',
          'SALIR': 'Exit',
          'VALIDAR': 'Bevestig bedrijf',
          'ERRORNOMBREEMPRESA': 'De naam van het ingevoerde bedrijf komt niet overeen met de naam van het te schrappen bedrijf',
          'MENSAJE': ' Weet je het zeker? Je staat op het punt om het bedrijf te verwijderen',
          'CANCELAR': 'Annuleren',
          'CONFIRMAR': 'Ja, verwijder',
          'SUCCES': 'Bedrijf geëlimineerd',
          'CERRAR': 'Sluiten'
        },
        'LOG_SENDGRIND':{
          'CARGANDO': 'Laadgegevens, wacht even...',
          'ASUNTO': 'U moet een onderwerp kiezen',
          'CONFIRMAR': 'Sluiten'
        }
      }
    }
};
